<template>
    <div >
        <div class="card-body">
                <el-form size="mini">
                    <el-form-item label="订单总价">
                        {{$parentInfo.equipmentLeasing.dialog_settlement.sumPay|currency('￥',2)}}
                    </el-form-item>
                    <el-form-item label="家长">
                        <el-select v-model="$parentInfo.equipmentLeasing.dialog_settlement.parent_id"
                                   placeholder="请选择家长">
                            <el-option
                                    v-for="item in $parentInfo.student.parents"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                <span style="float: left">{{ item.name }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.parent_identity }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-row :gutter="20" v-for="(payment,index) in $parentInfo.studentCart.dialog_SettleAccounts.payments" :key="index">
                        <el-col :span="1">
                            <div style="height:30px;width:30px;display: flex; justify-content:center;align-items: center;">
                                <div class="circle" :style="{'background':payment.status=='finished'?'green':'red'}" @click="handRefreshCartPayment(payment)"></div>
                            </div>
                        </el-col>
                        <el-col :span="9">
                            <el-form-item label="支付方式" >
                                <el-select v-model="payment.paymentType_id"
                                           placeholder="请选择支付方式"
                                           :disabled="!payment.canDel"
                                           style="width:200px"
                                           @change="handRefreshCartPayment(payment)">
                                    <el-option
                                            v-for="item in $parentInfo.equipmentLeasing.paymentTypes"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-input :disabled="payment.paymentType_id===5" v-model="payment.balance" v-if="payment.paymentType_id!=16" @change="handRefreshCartPayment(payment)"></el-input>
                            <el-select v-model="payment.other_id"
                                       placeholder="请选择押金"
                                       :disabled="!payment.canDel"
                                       @change="handRefreshCartPayment(payment)"
                                       v-else>
                                <el-option
                                        v-for="item in $parentInfo.studentCart.dialog_SettleAccounts.studentDeposits"
                                        :key="item.id"
                                        :label="item.balance"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="3">
                            <div>
                                <el-popover
                                        placement="right"
                                        title=""
                                        width="270"
                                        trigger="click">
                                    <div class="qrcode_box">
                                        <canvas id="msg" class="qrcode"></canvas>
                                        <div style="text-align: center">
                                            <el-upload
                                                    class="upload-demo"
                                                    :action="action"
                                                    :on-preview="handlePreview"
                                                    :on-remove="handleRemove"
                                                    :file-list="fileList"
                                                    :limit="1"
                                                    list-type="picture">
                                                <el-button size="small" type="primary">本地上传</el-button>
                                            </el-upload>
                                        </div>
                                    </div>
                                    <el-button slot="reference" @click="getQRCodeMsg(payment)">点击上传</el-button>
                                </el-popover>
                            </div>

                        </el-col>
                        <el-col :span="2">
                            <el-button type="primary" @click="handleDelPayment(payment)"  :disabled="!payment.canDel">删除</el-button>
                        </el-col>
                        <el-col :span="4">
                            <div style="height:30px;width:30px;display: flex; justify-content:center;align-items: center;">
                                <div v-if="payment.bill_url">
                                    <el-popover
                                            placement="right"
                                            trigger="click">
                                        <img :src="payment.bill_url" style="width: 500px;height: 500px">
                                        <div slot="reference" @click="" style="width: 50px;height: 50px">
                                            <img :src="payment.bill_url" alt=""
                                                 style="width: 50px;height: 50px">
                                        </div>
                                    </el-popover>
                                </div>
                                <div v-else>
                                    无
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <div style="text-align: right">
                        <el-button type="primary" @click="handleAddPayment()">新增支付方式</el-button>
                    </div>
                    <el-form-item label="结算差价">
                        {{remainPay|currency('￥',2)}}
                    </el-form-item>
                </el-form>
                <div style="text-align: right">
                    <el-button type="primary" @click="handleCheckOut()"
                               :loading="$parentInfo.equipmentLeasing.dialog_settlement.button_loading">确 认 支 付
                    </el-button>
                </div>
            </div>
    </div>
</template>

<script>
    import QRCode from 'qrcode'
    export default {
        name: "Dialog_SettleAccounts",
        data() {
            return {
                isMounted: false,
                QRCodeMsg:'234',
                choosePayment_id:'',
                fileList: [],
                payment_types:[]
            };
        },
        destroyed(){

        },
        computed: {
            action(){
                return "https://server.modijiaoyu.com/api/cart/paymentBill?payment_id="+this.choosePayment_id
            },
            remainPay: function () {
                let sum = 0;
                for (const key in this.$parentInfo.studentCart.dialog_SettleAccounts.payments) {
                    if (this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].balance) {
                        sum += parseFloat(this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].balance);
                    }
                }
                return this.$parentInfo.equipmentLeasing.dialog_settlement.sumPay - sum ;
            },

        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleCleanCartSelect();
        },
        methods: {
            handleCleanCartSelect(){
                this.$wApi.send(this.$parentInfo.path, 'clean_cart_select', {
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleCheckOut() {
                for (const key in this.$parentInfo.studentCart.dialog_SettleAccounts.payments) {
                    if (this.$parentInfo.studentCart.dialog_SettleAccounts.payments[key].status!='finished') {
                        this.$message({
                            message: '有支付方式未完成验证',
                            type: 'warning'
                        });
                        return 0;
                    }
                }
                this.$confirm('确认结算?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.studentCart.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'settlement_cart_shop', {
                        'cartShops': this.$parentInfo.equipmentLeasing.cartShops,
                        'payments': this.$parentInfo.studentCart.dialog_SettleAccounts.payments,
                        'trying_checked':this.$parentInfo.equipmentLeasing.checked,
                        'student_id': this.$parentInfo.student_id,
                        'parent_id':this.$parentInfo.equipmentLeasing.dialog_settlement.parent_id
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleAddPayment(){
                this.$wApi.send(this.$parentInfo.path, 'add_cart_payment', {
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleDelPayment(item){
                this.$wApi.send(this.$parentInfo.path, 'del_cart_payment', {
                    'cart_payment_id': item.id,
                });
            },
            handRefreshCartPayment(item){
                this.$wApi.send(this.$parentInfo.path, 'refresh_cart_payment', {
                    'cart_payment_id': item.id,
                    'paymentType_id':item.paymentType_id,
                    'balance':item.balance,
                    'other_id':item.other_id
                });
            },
            getQRCodeMsg(payment){
                this.QRCodeMsg='http://server.modijiaoyu.com/api/cart/storePaymentBill?cart_payment_id='+payment.id
                this.choosePayment_id=payment.id
                var msg= document.getElementById('msg')
                // 将获取到的数据（val）画到msg（canvas）上
                QRCode.toCanvas(msg, this.QRCodeMsg, function (error) {})
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            }
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 300px;
    }

    .right {
        margin-left: 310px;
    }

    .circle {
        border-radius: 50%;
        width: 20px;
        height:  20px;
        line-height: 20px;
    }

    .qrcode_box{
        width: 250px!important;
        height:  400px!important;
        .qrcode{
            width: 250px!important;
            height: 250px!important;
        }
    }

    #msg{
        width:250px !important;
        height:250px !important;
    }
</style>
